(function () {

  /* ── Money formatting ─────────────────────────────────────────────────── */

  function formatMoney(cents) {
    /* Prefer Shopify's built-in formatter if available */
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    /* Fall back to the money_format injected by main-article.liquid */
    var cfg    = window.__fcbConfig || {};
    /* Swap decimal placeholders for their no-decimals equivalents */
    var format = (cfg.moneyFormat || '{{amount}}')
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}')
      .replace('{{amount_with_period_separator}}', '{{amount_no_decimals}}');
    var amount = cents / 100;

    /* Build the four standard Shopify placeholder values */
    var amt           = amount.toFixed(2);
    var amtNoDec      = String(Math.floor(amount));
    var amtComma      = amount.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var amtCommaNoD   = amtNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amtDot        = amtComma.replace(/,/g, '.'); /* some locales use dot as thousands */

    return format
      .replace('{{amount_with_comma_separator}}',          amtComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amtCommaNoD)
      .replace('{{amount_with_period_separator}}',         amtDot)
      .replace('{{amount_no_decimals}}',                   amtNoDec)
      .replace('{{amount}}',                               amt);
  }

  /* ── Swatch config ────────────────────────────────────────────────────── */

  function swatchStyle(colorName) {
    var swatches = (window.__fcbConfig || {}).swatches || {};
    return swatches[(colorName || '').toLowerCase()] || 'background-color:#ccc';
  }

  /* ── General helpers ──────────────────────────────────────────────────── */

  function parseList(str) {
    if (!str) return [];
    return str.replace(/[{}]/g, '').split(',').reduce(function (acc, raw) {
      var entry = raw.trim();
      if (!entry) return acc;
      var idx = entry.indexOf(':');
      if (idx === -1) { acc.push({ handle: entry, color: '' }); return acc; }
      acc.push({ handle: entry.slice(0, idx).trim(), color: entry.slice(idx + 1).trim() });
      return acc;
    }, []);
  }

  function findVariant(variants, color) {
    if (!color || !variants.length) return variants[0] || null;
    var lc = color.toLowerCase();
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if ((v.option1 && v.option1.toLowerCase() === lc) ||
          (v.option2 && v.option2.toLowerCase() === lc) ||
          (v.option3 && v.option3.toLowerCase() === lc)) return v;
    }
    return variants[0];
  }

  function cdnResize(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src.startsWith('//') ? 'https:' + src : src);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (_) { return src; }
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── Swatch strip (mirrors product-card show_variants: true, limit 3) ── */

  var COLOR_OPTION_NAMES = ['color', 'colour', 'farve'];

  function buildSwatches(product, activeVariant) {
    try {
    if (!product.options || !product.options.length) return '';

    /* Find which option position is the colour option.
       The AJAX API can return options as plain strings OR as objects {name, values}.
       Handle both. */
    var colorPos = -1;
    for (var i = 0; i < product.options.length; i++) {
      var optName = product.options[i];
      if (optName && typeof optName === 'object') optName = optName.name || '';
      if (COLOR_OPTION_NAMES.indexOf(String(optName).toLowerCase()) !== -1) {
        colorPos = i;
        break;
      }
    }
    if (colorPos === -1) return '';

    var optionKey = 'option' + (colorPos + 1);

    /* Collect unique colour values preserving order */
    var seen = {};
    var colors = [];
    product.variants.forEach(function (v) {
      var val = v[optionKey];
      if (val && !seen[val]) { seen[val] = true; colors.push(val); }
    });
    if (!colors.length) return '';

    var activeColor = activeVariant[optionKey] || '';

    /* Bubble the active colour to front so it's always the first swatch shown */
    var activeIdx = colors.indexOf(activeColor);
    if (activeIdx > 0) {
      colors.splice(activeIdx, 1);
      colors.unshift(activeColor);
    }

    var limit   = 3;
    var shown   = colors.slice(0, limit);
    var extra   = colors.length - limit;

    var swatchHtml = shown.map(function (colorVal) {
      /* Find a variant for this colour to build the URL */
      var targetVariant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i][optionKey] === colorVal) {
          targetVariant = product.variants[i];
          break;
        }
      }
      var href  = targetVariant ? '/products/' + product.handle + '?variant=' + targetVariant.id : '#';
      var isActive = colorVal === activeColor ? ' is-active' : '';

      return (
        '<label class="radio__label radio__label--color' + isActive + '">' +
          '<a href="' + esc(href) + '" tabindex="-1" aria-label="' + esc(colorVal) + '">' +
            '<span class="radio__value radio__value--color" style="' + swatchStyle(colorVal) + '"></span>' +
          '</a>' +
        '</label>'
      );
    }).join('');

    var moreHtml = (extra > 0)
      ? '<a href="/products/' + product.handle + '" class="radio__show-more radio__show-more--buttons">+ ' + extra + ' more</a>'
      : '';

    return (
      '<div class="card__variants">' +
        '<div class="variant-selector">' +
          '<div class="variant-radios">' +
            '<fieldset class="variant-selector__option option">' +
              '<div class="option__radio">' +
                '<div class="radio">' + swatchHtml + moreHtml + '</div>' +
              '</div>' +
            '</fieldset>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
    } catch (e) {
      console.warn('[fcb] buildSwatches error:', e);
      return '';
    }
  }

  /* ── Grid layout styles (injected once per uid) ───────────────────────── */

  function injectStyles(uid, colsD, arrowOffsetL, arrowOffsetR) {
    var sid = 'fcb-style-' + uid;
    if (document.getElementById(sid)) return;
    var s = document.createElement('style');
    s.id = sid;
    s.textContent =
      '#' + uid + ' .fcb-heading{margin:0 0 20px}' +

      /* ── Mobile: horizontal scroll slider ── */
      '#' + uid + ' .fcb-grid{list-style:none;margin:0;padding:0;display:flex;flex-wrap:nowrap;' +
        'overflow-x:scroll;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;' +
        'scrollbar-width:none;gap:12px;padding-right:16px}' +
      '#' + uid + ' .fcb-grid::-webkit-scrollbar{display:none}' +
      '#' + uid + ' .fcb-grid>li{flex:0 0 75%;scroll-snap-align:start;min-width:0}' +

      /* ── Desktop: regular grid ── */
      '@media(min-width:750px){' +
        '#' + uid + ' .fcb-grid{display:grid;overflow-x:visible;scroll-snap-type:none;' +
          'gap:24px;padding-right:0;grid-template-columns:repeat(' + colsD + ',1fr)}' +
        '#' + uid + ' .fcb-grid>li{flex:none}' +
      '}' +

      /* Force square images regardless of .card__media height:100% */
      '#' + uid + ' .fcb-grid img.card__media{height:auto;width:100%;aspect-ratio:1/1;object-fit:cover;display:block}' +
      '#' + uid + ' .fcb-color-name{font-size:.8em;opacity:.6;margin:.2em 0}' +

      /* ── Mobile slider arrows — absolutely centred on the image area ── */
      /* Cards are flex:0 0 75%, images are 1:1, so image height ≈ 75% of slider width.
         Article padding is typically ~24px each side, so image height ≈ 0.75*(100vw-48px).
         Vertical centre of image ≈ calc(37.5vw - 18px).                                   */
      '#' + uid + ' .fcb-slider-outer{position:relative}' +
      '#' + uid + ' .fcb-prev,#' + uid + ' .fcb-next{' +
        'appearance:none;position:absolute;top:calc(37.5vw - 18px);transform:translateY(-50%);' +
        'z-index:2;border:none;background:#fff;' +
        'color:var(--color-text,#111);width:27px;height:27px;border-radius:0;cursor:pointer;' +
        'display:inline-flex;align-items:center;justify-content:center;padding:0;' +
        'transition:opacity .2s ease;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,.12)}' +
      '#' + uid + ' .fcb-prev{left:' + arrowOffsetL + 'px}' +
      '#' + uid + ' .fcb-next{right:' + arrowOffsetR + 'px}' +
      '#' + uid + ' .fcb-prev:hover,#' + uid + ' .fcb-next:hover{opacity:.6}' +
      '#' + uid + ' .fcb-prev.fcb-nav--dim,#' + uid + ' .fcb-next.fcb-nav--dim{opacity:.2;pointer-events:none}' +
      '@media(min-width:750px){#' + uid + ' .fcb-prev,#' + uid + ' .fcb-next{display:none}}';
    document.head.appendChild(s);
  }

  /* ── Build a card using the theme's product-card HTML structure ───────── */

  function buildCard(product, variant, color, opts) {
    var variantUrl = '/products/' + product.handle + '?variant=' + variant.id;
    var imgSrc = (variant.featured_image && variant.featured_image.src) || product.featured_image;
    var imgAlt = (variant.featured_image && variant.featured_image.alt) || product.title;

    /*
      The theme applies card__media classes directly to <img> (via component-image),
      NOT to a wrapper div. Replicating that here ensures the same CSS applies.
    */
    var imgClass = 'card__media card__media--square card__media-simple';

    var imgHtml = imgSrc
      ? '<img' +
          ' class="' + imgClass + '"' +
          ' src="'    + esc(cdnResize(imgSrc, 533)) + '"' +
          ' srcset="' + esc(cdnResize(imgSrc, 533)) + ' 533w,' +
                        esc(cdnResize(imgSrc, 720)) + ' 720w"' +
          ' loading="lazy"' +
          ' style="object-position:center center"' +
          ' alt="' + esc(imgAlt) + '">'
      : '';

    var colorHtml = (opts.showColor && color)
      ? '<div class="fcb-color-name">' + esc(color) + '</div>'
      : '';

    var priceHtml = opts.showPrice
      ? '<div class="card__price">' +
          '<div class="price">' +
            '<div class="price__container">' +
              '<span class="price__regular">' + formatMoney(variant.price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      : '';

    var swatchesHtml = buildSwatches(product, variant);

    return (
      '<li>' +
        '<div class="card-wrapper product-card-wrapper product-center">' +
          '<div class="card product">' +
            '<div class="card__inner">' +
              '<div class="card__media relative overflow-hidden">' +
                '<a href="' + esc(variantUrl) + '">' +
                  '<div class="media__skeleton absolute inset-0"></div>' +
                  imgHtml +
                '</a>' +
              '</div>' +
            '</div>' +
            '<div class="card__content">' +
              '<div>' +
                '<div class="card__header">' +
                  '<div class="card__title">' +
                    '<a href="' + esc(variantUrl) + '">' + esc(product.title) + '</a>' +
                  '</div>' +
                '</div>' +
                colorHtml +
                priceHtml +
              '</div>' +
              swatchesHtml +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>'
    );
  }

  /* ── Render a single container ────────────────────────────────────────── */

  function renderContainer(el) {
    if (el.dataset.fcbDone) return;
    el.dataset.fcbDone = '1';

    var productStr = el.getAttribute('data-fcb-products') || '';
    var colsD      = parseInt(el.getAttribute('data-fcb-cols'), 10)   || 3;
    var colsM      = parseInt(el.getAttribute('data-fcb-cols-m'), 10) || 2;
    var heading    = el.getAttribute('data-fcb-heading')       || '';
    var hlevel     = el.getAttribute('data-fcb-heading-level') || 'h2';
    var aspect     = el.getAttribute('data-fcb-aspect')        || 'square';
    var showPrice     = el.getAttribute('data-fcb-show-price') !== null;
    var showColor     = el.getAttribute('data-fcb-show-color') !== null;
    var arrowOffsetL  = parseInt(el.getAttribute('data-fcb-arrow-offset-left'),  10);
    var arrowOffsetR  = parseInt(el.getAttribute('data-fcb-arrow-offset-right'), 10);
    if (isNaN(arrowOffsetL)) arrowOffsetL = 4;
    if (isNaN(arrowOffsetR)) arrowOffsetR = 4;

    var uid = el.id || ('fcb-' + Math.random().toString(36).slice(2, 9));
    el.id = uid;

    var entries = parseList(productStr);
    if (!entries.length) return;

    injectStyles(uid, colsD, arrowOffsetL, arrowOffsetR);

    Promise.all(entries.map(function (e) {
      return fetch('/products/' + encodeURIComponent(e.handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      try {
        var headingHtml = heading
          ? '<' + hlevel + ' class="fcb-heading">' + esc(heading) + '</' + hlevel + '>'
          : '';

        var items = '';
        products.forEach(function (product, i) {
          if (!product) return;
          try {
            var entry   = entries[i];
            var variant = findVariant(product.variants, entry.color);
            if (!variant) return;
            items += buildCard(product, variant, entry.color, {
              aspect:    aspect,
              showPrice: showPrice,
              showColor: showColor
            });
          } catch (e) {
            console.warn('[fcb] card build error for', entries[i] && entries[i].handle, e);
          }
        });

        var arrowSvgL = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 2L2 8L8 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        var arrowSvgR = '<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L8 8L2 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        el.innerHTML =
          headingHtml +
          '<div class="fcb-slider-outer">' +
            '<ul class="fcb-grid">' + items + '</ul>' +
            '<button class="fcb-prev" aria-label="Previous">' + arrowSvgL + '</button>' +
            '<button class="fcb-next" aria-label="Next">' + arrowSvgR + '</button>' +
          '</div>';

        /* ── Wire up arrow buttons ── */
        var grid    = el.querySelector('.fcb-grid');
        var prevBtn = el.querySelector('.fcb-prev');
        var nextBtn = el.querySelector('.fcb-next');

        function updateArrows() {
          if (!grid || !prevBtn || !nextBtn) return;
          prevBtn.classList.toggle('fcb-nav--dim', grid.scrollLeft <= 2);
          nextBtn.classList.toggle('fcb-nav--dim', grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2);
        }

        function scrollByCard(dir) {
          var card = grid && grid.querySelector('li');
          if (!card) return;
          grid.scrollBy({ left: dir * (card.offsetWidth + 12), behavior: 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
        if (grid)    grid.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
      } catch (e) {
        console.error('[fcb] render error:', e);
      }
    }).catch(function (e) {
      console.error('[fcb] fetch error:', e);
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */

  function init() {
    document.querySelectorAll('[data-fcb-products]:not([data-fcb-done])').forEach(renderContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
